<template>
  <div>
    <listings hideMenu="true"></listings>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>
